export const environment = {
  production: false,
  apiUrl: '/api',
  mapboxToken: 'pk.eyJ1IjoiZHJ6enoiLCJhIjoiY21hYmJqM2pyMjJrMTJscTQwcHdsMzR4aiJ9.gfz2xKkeVkKEFN9B3lonbg',
};
